import { render, staticRenderFns } from "./SideNavLogo.vue?vue&type=template&id=23cb4280&scoped=true&"
import script from "./SideNavLogo.vue?vue&type=script&lang=js&"
export * from "./SideNavLogo.vue?vue&type=script&lang=js&"
import style0 from "./SideNavLogo.vue?vue&type=style&index=0&id=23cb4280&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23cb4280",
  null
  
)

export default component.exports